import type { EventName } from "@lit/react";
import { GridSelectionColumn as GridSelectionColumnElement, type GridSelectionColumnEventMap as _GridSelectionColumnEventMap, } from "@vaadin/grid/vaadin-grid-selection-column.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridSelectionColumnElement, };
export type GridSelectionColumnEventMap = Readonly<{
    onSelectAllChanged: EventName<_GridSelectionColumnEventMap["select-all-changed"]>;
}>;
const events = { onSelectAllChanged: "select-all-changed" } as GridSelectionColumnEventMap;
export type GridSelectionColumnProps<T1> = WebComponentProps<GridSelectionColumnElement<T1>, GridSelectionColumnEventMap>;
export const GridSelectionColumn = createComponent({
    elementClass: GridSelectionColumnElement, events, react: React, tagName: "vaadin-grid-selection-column"
}) as <T1>(props: GridSelectionColumnProps<T1> & React.RefAttributes<GridSelectionColumnElement<T1>>) => React.ReactElement | null;
